export function BrandMark() {
  return (
    <svg className="brand__mark" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="18" fill="var(--ink)" />
      <circle cx="32" cy="32" r="17" fill="none" stroke="var(--accent)" strokeWidth="7" strokeLinecap="round" strokeDasharray="80 107" transform="rotate(-90 32 32)" />
      <circle cx="32" cy="32" r="5" fill="var(--ai)" />
    </svg>
  );
}
